
import { defineComponent, reactive } from 'vue';
import useLocalStorage from 'vue-use-local-storage';
import faker from 'faker';

export default defineComponent({
  name: 'App',
  setup() {
    faker.seed(1);
    const state = reactive({
      persistValue: faker.name.firstName(),
      ignoreValue: faker.name.firstName()
    });

    useLocalStorage(state, 'someKey', ['persistValue']).onRehydrate((state) => {
      console.log(state);
    });

    function onRandomPersist() {
      state.persistValue = faker.name.firstName();
    }

    function onRandomNotPersist() {
      state.ignoreValue = faker.name.firstName();
    }

    return {
      onRandomPersist,
      onRandomNotPersist,
      state
    };
  }
});
